import { render, staticRenderFns } from "./MainFacInfo2.vue?vue&type=template&id=2e7ebf39&scoped=true&"
import script from "./MainFacInfo2.vue?vue&type=script&lang=js&"
export * from "./MainFacInfo2.vue?vue&type=script&lang=js&"
import style0 from "./MainFacInfo2.vue?vue&type=style&index=0&id=2e7ebf39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ebf39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
